import { Jackpot } from '@/components/templates/Jackpot/templates/Jackpot'
import { memo } from 'react'

const JackpotPage = () => {
  return <Jackpot />
}
{
  /* <Alert mb="4" background="brand.yellow" rounded="xl" status="warning" fontWeight="700">
    Due to testnet network problems, Jackpot Game is currently unavailable. We will solve the problem as quickly
    as possible.
  </Alert> */
}

export default memo(JackpotPage)
